import React from "react"
import SchemeButton from "./SchemeButton"
import type {SearchScheme, SelectedScheme} from "@/types/SearchScheme"

const schemes: SearchScheme[] = ["sale", "rent"]

interface SearchSchemeToggleProps {
   value: SelectedScheme
   onChange: (nextValue: SelectedScheme) => void
}

export const getNextScheme = (current: SelectedScheme, pressed: SearchScheme): SelectedScheme =>
   current === pressed ? null : pressed

export default function SearchSchemeToggle({value, onChange}: SearchSchemeToggleProps) {
   const handlePress = (pressed: SearchScheme) => {
      onChange(getNextScheme(value, pressed))
   }

   return (
      <div className="flex items-center gap-2" role="group" aria-label="Filtrar por operación">
         {schemes.map((scheme) => (
            <SchemeButton key={scheme} scheme={scheme} selected={value === scheme} onPress={handlePress} />
         ))}
      </div>
   )
}
